export default __webpack_public_path__ + "static/media/SolidCircle.984f229d.png";